import {
    RESOURCES_REQUESTED, RESOURCES_SUCCEEDED, RESOURCES_FAILED,
    SEARCH_REQUESTED, SEARCH_SUCCEEDED, SEARCH_FAILED,
    PREVIEW_SEARCH_REQUESTED, PREVIEW_SEARCH_SUCCEEDED, PREVIEW_SEARCH_FAILED,
    MEDIA_UPLOAD_REQUESTED, MEDIA_UPLOAD_SUCCEEDED, MEDIA_UPLOAD_FAILED,
    VIDEO_UPLOAD_REQUESTED, VIDEO_UPLOAD_SUCCEEDED, VIDEO_UPLOAD_FAILED, VIDEO_UPLOAD_STATUS
} from '../actions/media';

const initialState = {
    data: null,
    fetching: null,
    error: false
};

const initialPreviewState = {};

export const resources = (state = initialState, action) => {
    switch (action.type) {
        case RESOURCES_REQUESTED:
        case MEDIA_UPLOAD_REQUESTED:
            return {
                ...state,
                fetching: true,
                error: false
            };
        case RESOURCES_SUCCEEDED:
            return {
                data: action.data,
                fetching: false,
                error: false
            };
        case MEDIA_UPLOAD_SUCCEEDED:
            const resources = state.data && state.data.resources || [];

            return {
                data: {
                    resources: [action.data.data].concat(resources)
                },
                fetching: false,
                error: false
            };
        case RESOURCES_FAILED:
        case MEDIA_UPLOAD_FAILED:
            return {
                ...state,
                error: true
            };
        default:
            return {
                ...state
            };
    }
};

export const video = (state = {}, action) => {
    switch (action.type) {
        case VIDEO_UPLOAD_REQUESTED:
            return {
                ...state,
                started: true
            };
        case VIDEO_UPLOAD_SUCCEEDED:
            return {
                ...state,
                uploadedId: action.data,
                status: 'init'
            };
        case VIDEO_UPLOAD_FAILED:
            return {
                ...state,
                failed: true
            };
        case VIDEO_UPLOAD_STATUS:
            return {
                ...state,
                status: action.data
            };
        default:
            return {
                ...state
            };
    }
};

export const dmSearch = (state = initialState, action) => {
    const objects = state.data && state.data.objects || [];

    switch (action.type) {
        case SEARCH_REQUESTED:
            return {
                ...state,
                fetching: true,
                error: false
            };
        case SEARCH_SUCCEEDED:
            return {
                data: {
                    ...action.data,
                    objects: setDmSearchResult(action.resetResult, action.data.objects, objects)
                },
                fetching: false,
                error: false
            };
        case SEARCH_FAILED:
            return {
                ...state,
                error: true
            };
        default:
            return {
                ...state
            }
    }
};

export const previewDmSearch = (state = initialPreviewState, action) => {
    switch (action.type) {
        case PREVIEW_SEARCH_REQUESTED:
            return {
                ...state,
                [action.query]: {
                    ...initialState,
                    fetching: true
                }
            };
        case PREVIEW_SEARCH_SUCCEEDED:
            return {
                ...state,
                [action.query]: {
                    data: action.data,
                    fetching: false,
                    error: false
                }
            };
        case PREVIEW_SEARCH_FAILED:
            return {
                ...state,
                [action.query]: {
                    error: true
                }
            };
        default:
            return {
                ...state
            }
    }
};

const setDmSearchResult = (reset, newRes, res = null) => {
    if (reset) {
        return newRes;
    } else {
        return res.concat(newRes);
    }
};
